"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionRequest = exports.EventSubscriptionRequest = void 0;

var _filteringRequest = require("./filtering-request");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @typedef EventSubscriptionCallbacks
 *
 * A pair of callbacks that allow to add an event consumer to the subscription and to cancel it
 * respectively.
 *
 * @property {consumerCallback<eventConsumer>} subscribe the callback which allows to setup an
 *                                                       event consumer to use for the subscription
 * @property {parameterlessCallback} unsubscribe the callback which allows to cancel the
 *                                               subscription
 */

/**
 * An abstract base for requests that subscribe to messages of a certain type.
 *
 * @abstract
 * @template <T> the target type of messages, for events the type is always `spine.core.Event`
 */
var SubscribingRequest = /*#__PURE__*/function (_FilteringRequest) {
  _inherits(SubscribingRequest, _FilteringRequest);

  var _super = _createSuper(SubscribingRequest);

  function SubscribingRequest() {
    _classCallCheck(this, SubscribingRequest);

    return _super.apply(this, arguments);
  }

  _createClass(SubscribingRequest, [{
    key: "topic",
    value:
    /**
     * Builds a `Topic` instance based on the currently specified filters.
     *
     * @return {spine.client.Topic} a `Topic` instance
     */
    function topic() {
      return this._builder().build();
    }
    /**
     * Posts a subscription request and returns the result as `Promise`.
     *
     * @return {Promise<EntitySubscriptionObject<Message> | EventSubscriptionObject>}
     *         the asynchronously resolved subscription object
     */

  }, {
    key: "post",
    value: function post() {
      var topic = this.topic();
      return this._subscribe(topic);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_newBuilderFn",
    value: function _newBuilderFn() {
      var _this = this;

      return function (requestFactory) {
        return requestFactory.topic().select(_this.targetType);
      };
    }
    /**
     * @abstract
     * @return {Promise<EntitySubscriptionObject<Message> | EventSubscriptionObject>}
     *
     * @protected
     */

  }, {
    key: "_subscribe",
    value: function _subscribe(topic) {
      throw new Error('Not implemented in abstract base.');
    }
  }]);

  return SubscribingRequest;
}(_filteringRequest.FilteringRequest);
/**
 * A request to subscribe to updates of entity states of a certain type.
 *
 * Allows to obtain the `EntitySubscriptionObject` which exposes the entity changes in a form of
 * callbacks which can be subscribed to.
 *
 * A usage example:
 * ```
 * client.subscribeTo(Task.class)
 *       .where(Filters.eq("status", Task.Status.ACTIVE))
 *       // Additional filtering can be done here.
 *       .post()
 *       .then(({itemAdded, itemChanged, itemRemoved, unsubscribe}) => {
 *           itemAdded.subscribe(_addDisplayedTask);
 *           itemChanged.subscribe(_changeDisplayedTask);
 *           itemRemoved.subscribe(_removeDisplayedTask);
 *       });
 * ```
 *
 * If the entity matched the subscription criteria at one point, but stopped to do so, the
 * `itemRemoved` callback will be triggered for it. The callback will contain the last entity state
 * that matched the subscription.
 *
 * Please note that the subscription object should be manually unsubscribed when it's no longer
 * needed to receive the updates. This can be done with the help of `unsubscribe` callback.
 *
 * @template <T> the target entity type
 */


var SubscriptionRequest = /*#__PURE__*/function (_SubscribingRequest) {
  _inherits(SubscriptionRequest, _SubscribingRequest);

  var _super2 = _createSuper(SubscriptionRequest);

  /**
   * @param {!Class<Message>} entityType the target entity type
   * @param {!Client} client the client which initiated the request
   * @param {!ActorRequestFactory} actorRequestFactory the request factory
   */
  function SubscriptionRequest(entityType, client, actorRequestFactory) {
    _classCallCheck(this, SubscriptionRequest);

    return _super2.call(this, entityType, client, actorRequestFactory);
  }
  /**
   * @inheritDoc
   *
   * @return {Promise<EntitySubscriptionObject<Message>>}
   */


  _createClass(SubscriptionRequest, [{
    key: "_subscribe",
    value: function _subscribe(topic) {
      return this._client.subscribe(topic);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_self",
    value: function _self() {
      return this;
    }
  }]);

  return SubscriptionRequest;
}(SubscribingRequest);
/**
 * A request to subscribe to events of a certain type.
 *
 * Allows to obtain the `EventSubscriptionObject` which reflects the events that happened in the
 * system and match the subscription criteria.
 *
 * A usage example:
 * ```
 * client.subscribeToEvent(TaskCreated.class)
 *       .where([Filters.eq("task_priority", Task.Priority.HIGH),
 *              Filters.eq("context.past_message.actor_context.actor", userId)])
 *       .post()
 *       .then(({eventEmitted, unsubscribe}) => {
 *           eventEmitted.subscribe(_logEvent);
 *       });
 * ```
 *
 * The fields specified to the `where` filters should either be a part of the event message or
 * have a `context.` prefix and address one of the fields of the `EventContext` type.
 *
 * The `eventEmitted` observable reflects all events that occurred in the system and match the
 * subscription criteria, in a form of `spine.core.Event`.
 *
 * Please note that the subscription object should be manually unsubscribed when it's no longer
 * needed to receive the updates. This can be done with the help of `unsubscribe` callback.
 */


exports.SubscriptionRequest = SubscriptionRequest;

var EventSubscriptionRequest = /*#__PURE__*/function (_SubscribingRequest2) {
  _inherits(EventSubscriptionRequest, _SubscribingRequest2);

  var _super3 = _createSuper(EventSubscriptionRequest);

  /**
   * @param {!Class<Message>} eventType the target event type
   * @param {!Client} client the client which initiated the request
   * @param {!ActorRequestFactory} actorRequestFactory the request factory
   */
  function EventSubscriptionRequest(eventType, client, actorRequestFactory) {
    _classCallCheck(this, EventSubscriptionRequest);

    return _super3.call(this, eventType, client, actorRequestFactory);
  }
  /**
   * @inheritDoc
   *
   * @return {Promise<EventSubscriptionObject>}
   */


  _createClass(EventSubscriptionRequest, [{
    key: "_subscribe",
    value: function _subscribe(topic) {
      return this._client.subscribeToEvents(topic);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_self",
    value: function _self() {
      return this;
    }
  }]);

  return EventSubscriptionRequest;
}(SubscribingRequest);

exports.EventSubscriptionRequest = EventSubscriptionRequest;
//# sourceMappingURL=subscribing-request.js.map